import { lazy } from "react";
import RoleSwitch from "modules/swiftboard/components/RoleSwitch";

// /swiftboard/employee-management — role-based page
const pages = {
  ADMIN: lazy(() => import("./admin/page")),
};

export default function EmployeeManagement() {
  return <RoleSwitch pages={pages} />;
}
